import { h, Component } from 'preact'
import axios from 'axios'
import CodeMirror from '../codemirror/'
import AlertComponent from '../ui-components/AlertComponent'

interface Props {
  content: string
}

interface State {
  content: string,
  defaultValue: string,
  isError: boolean,
  isSaved: boolean,
  errorMessage: string
}

export default class CustomCss extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      content: props.content || '',
      defaultValue: props.content || '',
      isError: false,
      isSaved: false,
      errorMessage: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.submitHandler = this.submitHandler.bind(this)
    this.handleCloseNotification = this.handleCloseNotification.bind(this)
  }

  async submitHandler (e: Event) {
    e.preventDefault()

    try {
      await axios.post('/branding/updateCustomCss', {
        data: this.state.content
      })

      this.setState({
        isSaved: true
      })
    } catch (error) {
      let errorMessage: string = ''

      errorMessage = error.response.data.errors.customCss.reduce((accum:string, item:string) =>  {
        accum += '<br>' + item
        return accum
      })

      this.setState({
        isError: true,
        errorMessage: errorMessage
      })
    }
  }

  handleChange (data: string) {
    this.setState({
      content: data
    })
  }

  handleCloseNotification () {
    this.setState({
      isError: false,
      isSaved: false
    })
  }

  handleOpenEmbeddables () {
    const embeddablesButton: HTMLElement | null = document.querySelector('.insided-conversational-trigger-button')

    if (embeddablesButton) {
      embeddablesButton.click()
    }
  }

  render ({}: Props, { defaultValue, isError, isSaved, errorMessage }: State) {
    return (
      <div class='customCss'>
        <div class='customCss__note'>
          <p class='customCss__note-text'><span class='customCss__note-text-bold'>Note:</span> We recommend inviting a professional web developer to work with Custom CSS. Insert code at your own risk, and proceed with extreme caution. If you want to test your code before publishing we strongly recommend you to use your staging environment first. <button class='customCss__note-text-btn' type='button' onClick={this.handleOpenEmbeddables}>View Custom CSS examples</button></p>
        </div>

        {isError && <AlertComponent
          messageType='error'
          message={errorMessage}
          renderHTML
          onClose={this.handleCloseNotification}
        />}

        {isSaved && <AlertComponent
          messageType='success'
          onClose={this.handleCloseNotification}
        />}

        <form class='customCss__form' onSubmit={this.submitHandler}>
          <CodeMirror
            defaultValue={defaultValue}
            onChange={this.handleChange}
          />
          <button type='submit' id='js-submit-custom-css' class='hide' />
        </form>
      </div>
    )
  }
}
